import { useMemo } from 'react';
import * as brandcontent from '../brand-content';
import { useEverestConfig } from './useEverestConfig';

/**
 * How to use
 * * You could get the whole factory object
 * ```js
 * const factory = useBrandContentFactory();
 * factory.footerDisclaimer(...)
 * ```
 *
 * * Or destruct the factory to get what you only need
 * ```js
 * const { footerDisclaimer as footerDisclaimerFactory } = useBrandContentFactory();;
 * footerDisclaimerFactory({ comparisonUrl: '', fsgUrl: '' }) // that should return you the disclaimer string
 * ```
 * @returns {brandcontent.BrandConfiguration} the BrandConfiguration object that has multiple factories you may require
 */
export const useBrandContentFactory = () => {
    const { brandcode, verticalName } = useEverestConfig();

    // Memoize the factory to avoid re-creating it on every render
    // This hook could be used in multiple components
    // and Everest has a lot of unnecessary rerenders
    const brandContentFactory = useMemo(() => {
        return brandcontent.BrandContentFactory(brandcode, verticalName);
    }, [brandcode, verticalName]);

    return brandContentFactory;
};
